import { ORIGIN_STATE_ID } from '@upflowy/types';

export const getAllMatches = (regex: RegExp, text: string) => {
  const res = [];
  let match = null;
  if (regex.global) {
    /* eslint-disable-next-line */
    while ((match = regex.exec(text))) {
      res.push(match);
    }
    /* eslint-disable-next-line */
  } else if ((match = regex.exec(text))) {
    res.push(match);
  }
  return res;
};

export const getUtmParams = (params: URLSearchParams) =>
  [...params.keys()]
    .filter((k) => k.toLowerCase().startsWith('utm_'))
    .reduce((p, k) => ({ ...p, [k.toLowerCase()]: params.get(k) }), {});

export type UpflowyURLParams = {
  [key: string]: unknown;
  initial: string;
};

export const getUpflowyURLParams = (params: URLSearchParams): UpflowyURLParams => ({
  initial: ORIGIN_STATE_ID,
  ...[...params.keys()]
    .filter((k) => k.toLowerCase().startsWith('u-'))
    .reduce((p, k) => ({ ...p, [k.substring(2)]: params.get(k) }), {}),
});

export default getUpflowyURLParams;
